const en = {
  // ── App shell ──────────────────────────────────────────────────────────────
  navOperations:    'Operations',
  navResources:     'Resources',
  navAdministration:'Administration',
  logout:           'Logout',
  searchPlaceholder:'Search...',
  loadingOrgData:   'Loading organization data...',

  // ── Auth ───────────────────────────────────────────────────────────────────
  secureAccess:       'Secure Access',
  fleetMgmtSystem:    'Fleet Management System',
  smartFleet:         'Smart Fleet. Total Control.',
  login:              'Login',
  signUp:             'Sign Up',
  welcomeBack:        'Welcome back',
  createAccount:      'Create account',
  usernameOrEmail:    'Username Or Email',
  password:           'Password',
  enterUsernameEmail: 'Enter username or email',
  enterPassword:      'Enter password',
  signingIn:          'Signing In...',
  creatingAccount:    'Creating Account...',
  createAccountBtn:   'Create Account',
  username:           'Username',
  email:              'Email',
  firstName:          'First Name',
  lastName:           'Last Name',
  phoneNumber:        'Phone Number',
  mobilePhoneNumber:  'Mobile Phone Number',
  companyName:        'Organization Name',
  yourCompanyName:    'Your organization name',
  signupCode:         'Signup Code',
  signupCodeHint:     'Provided by your account manager.',
  confirmPassword:    'Confirm Password',

  // ── First Login ────────────────────────────────────────────────────────────
  setYourPassword:          'Set Your Password',
  firstLoginSubtitle:       'This is your first login. Please set a new password to continue.',
  newPassword:              'New Password',
  enterNewPassword:         'Enter new password',
  reEnterNewPassword:       'Re-enter new password',
  setPasswordContinue:      'Set Password & Continue',
  saving:                   'Saving...',

  // ── Common actions ─────────────────────────────────────────────────────────
  add:        'Add',
  edit:       'Edit',
  delete:     'Delete',
  save:       'Save',
  cancel:     'Cancel',
  confirm:    'Confirm',
  update:     'Update',
  remove:     'Remove',
  upload:     'Upload',
  close:      'Close',

  // ── Common labels ──────────────────────────────────────────────────────────
  status:       'Status',
  name:         'Name',
  type:         'Type',
  fleet:        'Fleet',
  organization: 'Organization',
  zone:         'Zone',
  role:         'Role',
  photo:        'Photo',
  notes:        'Notes',
  actions:      'Actions',
  description:  'Description',
  noDataFound:  'No data found.',
  unassigned:   'Unassigned',
  optional:     'optional',

  // ── Status values ──────────────────────────────────────────────────────────
  active:       'Active',
  inactive:     'Inactive',
  new:          'New',
  maintenance:  'Maintenance',
  allStatus:    'All Status',

  // ── Photo buttons ──────────────────────────────────────────────────────────
  uploadPhoto:  'Upload Photo',
  changePhoto:  'Change Photo',
  replacePhoto: 'Replace Photo',

  // ── Dashboard ──────────────────────────────────────────────────────────────
  activeVehicles:      'Active Vehicles',
  activeDrivers:       'Active Drivers',
  activeOrders:        'Active Orders',
  completed:           'Completed',
  revenue:             'Revenue',
  pending:             'Pending',
  ofTotal:             'of {n} total',
  inProgress:          'in progress',
  orders:              'orders',
  collected:           'collected',
  toCollect:           'to collect',
  revenueByFleet:      'Revenue by Fleet',
  revenueByVehicle:    'Revenue by Vehicle',
  completedOrders:     'Completed orders',
  orderStatus:         'Order Status',
  currentDistribution: 'Current distribution',
  recentOrders:        'Recent Orders',
  orderId:             'Order ID',
  driver:              'Driver',
  customer:            'Customer',
  amount:              'Amount',
  alertsNotices:       'Alerts & Notices',
  licenseExpiring:     'License expiring:',
  vehicleInMaintenance:'Vehicle in maintenance:',
  inTransit:           'In transit:',
  allSystemsOk:        'All systems operational',
  expires:             'Expires',
  started:             'Started',

  // ── Vehicles ───────────────────────────────────────────────────────────────
  vehiclesCount:   '{n} vehicles',
  addVehicle:      'Add Vehicle',
  editVehicle:     'Edit Vehicle',
  saveVehicle:     'Save Vehicle',
  noVehiclesFound: 'No vehicles found',
  vehicleLabel:    'Vehicle',
  plateVin:        'Plate / VIN',
  fuelType:        'Fuel type',
  odometer:        'Odometer',
  vehicleName:     'Vehicle name',
  plateNumber:     'Plate number',
  vin:             'VIN',
  make:            'Make',
  model:           'Model',
  year:            'Year',
  color:           'Color',
  capacity:        'Capacity (kg)',
  odometerKm:      'Odometer (km)',
  expectedConsumption: 'Expected Consumption (L/100km)',
  tankCapacity:        'Tank Capacity (L)',
  vendor:          'Vendor',
  gpsId:           'GPS ID',
  gpsPassword:     'GPS password',

  // ── Drivers ────────────────────────────────────────────────────────────────
  driversCount:        '{n} drivers',
  addDriver:           'Add Driver',
  editDriver:          'Edit Driver',
  saveDriver:          'Save Driver',
  noDriversFound:      'No drivers found',
  contact:             'Contact',
  licenseNo:           'License No.',
  licenseExpiry:       'License Expiry',
  driverDetails:       'Driver Details',
  firstNameLabel:      'First name',
  lastNameLabel:       'Last name',
  emailLabel:          'Email',
  phoneOptional:       'Phone',
  organizationLabel:   'Organization',
  fleetOptional:       'Fleet',
  zoneOptional:        'Zone',
  licenseNumber:       'License number',
  licenseExpiryLabel:  'License expiry',
  selectOrganization:  'Select organization...',
  expired:             'Expired',
  expiring:            'Expiring',

  // ── Security / Users ───────────────────────────────────────────────────────
  addUser:          'Add User',
  editUser:         'Edit User',
  saveUser:         'Save User',
  noUsersFound:     'No users found',
  changePassword:   'Change Password',
  oldPassword:      'Current Password',
  newPasswordLabel: 'New Password',
  views:            'Views',
  assignViews:      'Assign Views',

  // ── Orders ─────────────────────────────────────────────────────────────────
  addOrder:       'Add Order',
  editOrder:      'Edit Order',
  noOrdersFound:  'No orders found',
  origin:         'Origin',
  destination:    'Destination',
  scheduledAt:    'Scheduled At',
  currency:       'Currency',
  baseAmount:     'Base Amount',
  totalAmount:    'Total Amount',
  trackingNumber: 'Tracking #',

  // ── Fleets ─────────────────────────────────────────────────────────────────
  addFleet:      'Add Fleet',
  editFleet:     'Edit Fleet',
  noFleetsFound: 'No fleets found',
  code:          'Code',
  vehicles:      'Vehicles',
  drivers:       'Drivers',

  // ── Places ─────────────────────────────────────────────────────────────────
  addPlace:      'Add Place',
  editPlace:     'Edit Place',
  noPlacesFound: 'No places found',
  address:       'Address',
  city:          'City',
  country:       'Country',

  // ── Contacts ───────────────────────────────────────────────────────────────
  addContact:      'Add Contact',
  editContact:     'Edit Contact',
  noContactsFound: 'No contacts found',
  phone:           'Phone',

  // ── Vendors ────────────────────────────────────────────────────────────────
  addVendor:      'Add Vendor',
  editVendor:     'Edit Vendor',
  noVendorsFound: 'No vendors found',
  website:        'Website',

  // ── Transactions ───────────────────────────────────────────────────────────
  addTransaction:      'Add Transaction',
  editTransaction:     'Edit Transaction',
  noTransactionsFound: 'No transactions found',
  reference:           'Reference',
  paymentMethod:       'Payment Method',
  processedAt:         'Processed At',

  // ── Organization ───────────────────────────────────────────────────────────
  addOrganization:      'Add Organization',
  editOrganization:     'Edit Organization',
  noOrganizationsFound: 'No organizations found',
  zones:                'Zones',
  addZone:              'Add Zone',

  // ── Zones ──────────────────────────────────────────────────────────────────
  addZoneBtn:      'Add Zone',
  editZone:        'Edit Zone',
  noZonesFound:    'No zones found',
  zoneName:        'Zone Name',
  zoneDescription: 'Zone Description',

  // ── Settings ───────────────────────────────────────────────────────────────
  theme:         'Theme',
  notifications: 'Notifications',
  financial:     'Financial',
  whiteTheme:    'White Theme',
  blackTheme:    'Black Theme',

  // ── Confirm dialogs ────────────────────────────────────────────────────────
  confirmAdd:    'Confirm Add',
  confirmUpdate: 'Confirm Update',
  confirmDelete: 'Confirm Delete',

  // ── Nav items ──────────────────────────────────────────────────────────────
  navDashboard:    'Dashboard',
  navOrders:       'Orders',
  navTracking:     'Tracking Map',
  navVehicles:     'Vehicles',
  navDrivers:      'Drivers',
  navFleets:       'Fleets',
  navPlaces:       'Places',
  navContacts:     'Contacts',
  navCustomers:    'Customers',
  navVendors:      'Vendors',
  navTransactions: 'Transactions',
  navItems:        'Items',
  navSellOrders:   'Sell Orders',
  navSecurity:              'Security',
  navOrganization:          'Organization',
  navZones:                 'Zones',
  navGeofences:             'Geofences',
  navSettings:              'Settings',
  navUserSettings:          'User Settings',
  navSystemDefaults:        'System Default Settings',
  navPlans:                 'Plans & Subscriptions',
  navSysAdmin:              'System Administration',
  onPlan:                   'on plan',
  subscriptionExpired:      'Subscription expired',
  vehicleLimitReached:      'Vehicle limit reached',
  planAndStorage:           'Plan & Storage',
  planStorageSubtitle:      'Document storage used by your organization on its current plan.',
  planLoadFailed:           'Failed to load your plan.',
  noActiveSubscription:     'No active subscription.',
  currentPlan:              'Current plan',
  storageUsedLabel:         'Storage used',
  storageUsedOf:            '{used} of {limit} used',
  storageNoLimit:           '{used} used. This plan has no storage limit.',
  storageFull:              'Storage is full. New uploads will be rejected until you delete documents or upgrade your plan.',
  storageNearFull:          'You have used {percent}% of your storage. Consider upgrading your plan.',
  storageLimitReached:      'Storage limit reached',
  // Shorter than storageUsedOf — the drive icon beside it already says
  // "storage", and the longer form overflows the sidebar rail in Arabic.
  sidebarStorageOf:         '{used} of {limit}',
  planExpiredMessage:       'The subscription for your organization has expired. Please contact your account manager to renew it.',
  navRequiredDocuments:     'Required Documents Setup',
  navDocumentTypes:         'Document Types',
  navVehicleInventory:      'Inventory',
  navFuelManagement:        'Fuel Management',
  navFuelReports:           'Fuel Reports',
  navFuel:                  'Fuel',
};

export default en;
